import { Play } from 'lucide-react'
import { useState } from 'react'

interface CourseVideoProps {
  thumbnailUrl: string
  title: string
  description: string
}

export function CourseVideo({ thumbnailUrl, title, description }: CourseVideoProps) {
  const [isPlaying, setIsPlaying] = useState(false)

  const handlePlayVideo = () => {
    setIsPlaying(true)
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="relative w-full bg-slate-900 rounded-lg overflow-hidden shadow-lg" style={{ aspectRatio: "16 / 9" }}>
        {!isPlaying ? (
          // Thumbnail with play button
          <>
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url('${thumbnailUrl}')` }}
            />
            <div className="absolute inset-0 bg-black/20" />
            <button 
              onClick={handlePlayVideo}
              className="absolute inset-0 flex items-center justify-center group cursor-pointer"
            >
              <div className="flex size-16 items-center justify-center rounded-full bg-white/20 group-hover:bg-white/30 backdrop-blur-sm transition-all hover:scale-110">
                <Play className="w-8 h-8 text-white fill-white" />
              </div>
            </button>
          </>
        ) : (
          // Embedded YouTube video
          <iframe
            src="https://www.youtube.com/embed/0rHUDWjR5gg?autoplay=1&rel=0"
            title={title}
            className="absolute inset-0 w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            frameBorder="0"
          />
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h1 className="text-2xl text-gray-800 lg:text-3xl font-bold">{title}</h1>
        <p className="text-base text-gray-600">{description}</p>
      </div>
    </div>
  )
}